import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Y si debo poquito?',
  answer: 'Perfecto: es más fácil recuperar control rápido y evitar que crezca. El sistema te ayuda a liquidar esas deudas pequeñas con estrategia antes de que se conviertan en un problema mayor.'
}, {
  question: '¿Y si debo mucho?',
  answer: 'Más razón para tener mapa. Cuando la deuda es grande, improvisar es carísimo. Necesitas saber exactamente dónde estás parado para poder negociar con los bancos sin que te coman vivo.'
}, {
  question: '¿Me da pena que alguien se entere?',
  answer: 'Esto está hecho para que no tengas que explicarte ni exponerte. Es un proceso privado, paso a paso, que haces tú mismo/a con las plantillas. Nadie más tiene que saberlo.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después del pago recibirás un correo con el acceso al PDF y a las plantillas de Google Sheets. Puedes empezar en 5 minutos.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-14 bg-white" data-id="element-41">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-42">
        <h2 className="text-3xl font-bold text-slate-900 text-center mb-8" data-id="element-43">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-44">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-xl overflow-hidden hover:border-blue-200 transition-colors" data-id="element-45">
              <button className="w-full px-6 py-4 flex items-center justify-between bg-white text-left focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-46">
                <span className="font-semibold text-slate-900" data-id="element-47">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-blue-600" data-id="element-48" /> : <ChevronDown className="w-5 h-5 text-slate-400" data-id="element-49" />}
              </button>

              {openIndex === index && <div className="px-6 pb-6 pt-0 text-slate-600 bg-white animate-in slide-in-from-top-2 duration-200" data-id="element-50">
                  {faq.answer}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}